import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

import reportWebVitals from './reportWebVitals'

// Prefer build-time Agency Portal origin when set (staging/production via env-cmd).
const agencyPortalUrl = process.env.REACT_APP_AGENCY_PORTAL_URL
if (agencyPortalUrl) {
  window.__AGENCY_PORTAL_URL__ = agencyPortalUrl.replace(/\/$/, '')
  const match = window.location.hash.match(/#\/?leadProperties\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/i)
  if (match) {
    window.location.replace(`${window.__AGENCY_PORTAL_URL__}/leads/${match[1]}/detail?tab=contact`)
  }
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
